import Header from '@/features/Header';
import MainLayout from '@/shared/layouts/MainLayout';
import Dashboard from '@/widgets/Dashboard';
import { wrapper } from '@/global/store';
import { withUserDataFromCookie } from '@/processes/Auth';
import { SEO } from '@/processes/Router';

export default function Home() {
  return (
    <>
      <SEO noIndex={true}/>
      <Header 
        withAddonsLeft={true}
        withAddonsCenter={false}
        withAddonsRight={true}
      />
      <MainLayout>
        <Dashboard/>
      </MainLayout>
    </>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(withUserDataFromCookie);